﻿import * as eventTypes from '../../../map/utils/eventTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
export default class QuickSearchControl {
    constructor(resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, config) {
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.elementId = 'map-search-' + this.classId;
        this.active = false;
        this.origConfig = config;
        this.config = [];
        this.searchDataSourceList = [];
    }

    init() {
        if (this.origConfig.length > 0) {
            this.origConfig.forEach(item => {
                if (!item.Name.indexOf('*') == 0) {
                    this.config.push(item);
                }
            });
        }

        if (this.config.length == 0) {
            return;
        }

        this._createSearchControl();
    }

    _createSearchControl() {
        this.menuContainer.append(
            '<div class="map-search d-flex shadow-1" style="display:none;">'
            + '<div class="input-group-prepend">'
            + '<button title="' + this.resourcesHandler.get('Search Config') + '" class="btn btn-default btn-icon waves-effect waves-themed map-serach-config" type="button" style="border-radius: 4px 0 0 4px " > <i class="ni ni-menu"></i></button>'
            + '</div>'
            + '<input type="text" id="' + this.elementId + '" style="width:100%;"></input>'
            + '</div>'
        );

        var ref = this;
        $("#" + this.elementId).kendoComboBox({
            placeholder: this.resourcesHandler.get("Search"),
            dataTextField: "Name",
            dataValueField: "Name",
            filter: "contains",
            autoBind: false,
            suggest: true,
            delay: 1000,
            dataSource: {
                serverFiltering: true,
                filter: [],
                transport: {
                    read: {
                        url: this.rootURL + "Map/MapSearch",
                        data: () => {

                            if ($("#" + this.elementId).data("kendoComboBox").dataItem() == null
                                || $("#" + this.elementId).data("kendoComboBox").dataItem().Name != $("#" + this.elementId).data("kendoComboBox").input.val()) {
                                this.mapControl.showSearchResult(null, null, null);
                            }


                            var qs = [];
                            for (var i = 0; i < this.searchDataSourceList.length; i++) {
                                if (this.searchDataSourceList[i].Enabled) {
                                    qs.push(this.searchDataSourceList[i].Id);
                                }
                            }

                            return {
                                searchText: removeDiacritics($("#" + this.elementId).data("kendoComboBox").input.val()),
                                idMap: this.mapControl.mapId,
                                idMapSearch: JSON.stringify(qs)
                            }

                        }
                    },
                    prefix: ""
                },
                schema: {
                    parse: (resp) => {
                        var rows = Array.isArray(resp) ? resp : resp.data;

                        let criteria = $("#" + this.elementId).data("kendoComboBox").input.val();

                        if (criteria != null && criteria.trim().length >= 3) {
                            let nominatimSearch = this.config.find(x => x.Type == 'NOMINATIM' && x.Url != null && x.Url.trim() != '');

                            if (nominatimSearch != null) {
                                $.ajax({
                                    type: "GET",
                                    url: nominatimSearch.Url.replaceAll('{filter}', criteria.trim()),
                                    async: false,
                                    contentType: "application/json; charset=utf-8",
                                    success: (result) => {
                                        let results = [];

                                        if (result != null && result.length > 0) {
                                            result.forEach(x => {
                                                results.push({
                                                    IdMapSearch: nominatimSearch.Id,
                                                    Name: x.display_name,
                                                    IconClass: nominatimSearch.Icon,
                                                    Wkt: x.boundingbox,
                                                    Lat: x.lat,
                                                    Lon: x.lon,
                                                    DataSourceName: nominatimSearch.Name,
                                                    Type: 'NOMINATIM'
                                                });
                                            });
                                        }
                                        rows.forEach(x => {
                                            results.push(x);
                                        });

                                        rows = results;
                                    }
                                });
                            }
                        }

                        return rows;
                    }
                }
            },
            filtering: (e) => {
                var filterValue = e.filter ? e.filter.value : "";

                if (filterValue.length < 3) {
                    e.preventDefault();
                }
            },
            template: '<div class="d-flex"><div><span class="#: IconClass# pl-1 pt-1 pr-3" style="font-size:2rem;"> </span></div><div class="d-flex-column"><div class="color-primary" style="font-weight:400" >#: Name # </div><div>#: DataSourceName #</div></div></div>',
            noDataTemplate: (e) => {
                return this.resourcesHandler.get("No data found");
            },
            change: (e) => {

                if (e.sender.dataItem() != null) {

                    var wkt = e.sender.dataItem().Wkt;
                    var _dsConfig = null;
                    for (var i = 0; i < this.config.length; i++) {
                        if (this.config[i].Id == e.sender.dataItem().IdMapSearch) {
                            _dsConfig = this.config[i];
                            break;
                        }
                    }

                    var styleId = _dsConfig.IdStyle;
                    var minScale = _dsConfig.MinScale;

                    if (e.sender.dataItem().Type != null && e.sender.dataItem().Type == 'NOMINATIM') {
                        this.mapControl.showSearchResultBBox(wkt, e.sender.dataItem().Lat, e.sender.dataItem().Lon, styleId, minScale);
                    } else {
                        this.mapControl.showSearchResult(wkt, styleId, minScale);
                    }
                }
                else {
                    this.mapControl.showSearchResult(null, null, null);
                }
            },
            close: (e) => {

                if (e.sender.dataItem() == null || e.sender.dataItem().Name != e.sender.value()) {

                    this.mapControl.showSearchResult(null, null, null);
                }
                else {
                    var wkt = e.sender.dataItem().Wkt
                    var _dsConfig = null;
                    for (var i = 0; i < this.config.length; i++) {
                        if (this.config[i].Id == e.sender.dataItem().IdMapSearch) {
                            _dsConfig = this.config[i];
                            break;
                        }
                    }

                    var styleId = _dsConfig.IdStyle;
                    var minScale = _dsConfig.MinScale;

                    if (e.sender.dataItem().Type != null && e.sender.dataItem().Type == 'NOMINATIM') {
                        this.mapControl.showSearchResultBBox(wkt, e.sender.dataItem().Lat, e.sender.dataItem().Lon, styleId, minScale);
                    } else {
                        this.mapControl.showSearchResult(wkt, styleId, minScale);
                    }
                }
            }
        });
        $(".map-search .k-select").addClass("bg-primary");
        $(".map-search .k-select").addClass("text-white");
        $(".map-search .k-select .k-icon").removeClass("k-i-arrow-60-down");
        $(".map-search .k-select .k-icon").addClass("k-i-search");

        this._createSearchConfigControlPanel();
        $(".map-serach-config").click(this._handleSearchConfigClickEvent());

        $(".map-search").show();
    }

    _createSearchConfigControlPanel() {
        this.menuContainer.append(
            '<div class="js-modal-search-config" style="display:none;">'
            + '<div class="js-modal-search-config-header border-faded border-bottom-1 d-flex justify-content-left align-items-center pl-4" style="height:62px; position:relative;">'
            + '<h4 class="m-0 text-center " style="color:#212529;">'
            + this.resourcesHandler.get('Search Config')
            + '</h4>'
            + '<button style="color:#212529;" type="button" class="close  position-absolute pos-top pos-right p-2 m-1 mr-2"  title="' + this.resourcesHandler.get('Close') + '">'
            + '<span aria-hidden="true"><i class="fal fa-times"></i></span>'
            + '</button>'
            + '</div>'
            + '<div class="js-modal-search-config-body mt-2 mb-2 ml-3 mr-3" style="height:auto; position:relative;">'
            + '<div class="searchConfig"></div>'
            + '</div>'
            + '</div>'
        );

        this.menuContainer.find(".js-modal-search-config .close").click( () => {
            this.menuContainer.find(".js-modal-search-config").removeClass("show");
            this.menuContainer.find(".js-modal-search-config").hide();
        });

        this._createSearchConfigTree();
    }

    _handleSearchConfigClickEvent() {
        var clickHandler = () => {
            this.menuContainer.find(".js-modal-search-config").show();
            this.menuContainer.find(".js-modal-search-config").addClass("show");
        }

        return clickHandler;
    }

    _createSearchConfigTree() {
        this.searchDataSourceList = [];
        for (var i = 0; i < this.config.length; i++) {
            if (!this.config[i].Name.indexOf('*') == 0) {
                this.searchDataSourceList.push({
                    Name: this.resourcesHandler.get(this.config[i].Name),
                    Icon: this.config[i].Icon,
                    Id: this.config[i].Id,
                    Enabled: true
                });
            }
        }

        this.menuContainer.find(".searchConfig").kendoTreeView({
            loadOnDemand: false,
            dataSource: this.searchDataSourceList,
            dragAndDrop: false,
            template: '<div class="search-node" style="width: 100 %;" data-search-id="#: item.Id #">'
                + ' <div class= "custom-control custom-switch" style = "cursor: pointer !important;" >'
                + '<input type="checkbox" class="custom-control-input" id="search-nod-#:item.Id#" checked="" style="cursor: pointer !important;">'
                + '<label class="custom-control-label" for="search-nod-#:item.Id#" style="cursor: pointer !important;">#: item.Name#</label>'
                + '</div>'
                + ' </div>',
            select: (e) => {
                e.preventDefault();
            }
        });

        for (var i = 0; i < this.searchDataSourceList.length; i++) {
            $("#search-nod-" + this.searchDataSourceList[i].Id).change(this._getSwitchHandler(this.searchDataSourceList[i].Id));
        }

        this.menuContainer.find(".searchConfig").data("kendoTreeView").expand(".k-treeview-item");
    }

    _getSwitchHandler(dataSourceId) {
        var handler = () => {

            for (var i = 0; i < this.searchDataSourceList.length; i++) {
                if (this.searchDataSourceList[i].Id == dataSourceId) {
                    this.searchDataSourceList[i].Enabled = !this.searchDataSourceList[i].Enabled;
                }

                $("#" + this.elementId).data("kendoComboBox").dataSource.read();
            }
        }

        return handler;
    }
}